import ActivityFeed from '@/components/deal/activity-feed/activity-feed';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import useLocalStorage from '@/hooks/use-local-storage';
import { toast } from '@/hooks/use-toast';
import { cn } from '@/lib/utils';
import { Deal } from '@/models/registry';

import { ArrowDown01, ArrowDown10, CircleUser } from 'lucide-react';
import { observer } from 'mobx-react-lite';

export const NonMobileActivityFeed = observer(({ deal }: { deal: Deal }) => {
  const [orderBy, setOrderBy] = useLocalStorage<'newest' | 'oldest'>(
    'deal-activity-feed-order',
    'newest',
  );

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row items-center justify-between">
        <h6 className="scroll-m-20 text-md  tracking-tight">Activity</h6>
        <div className="flex flex-row gap-1 items-center">
          <Tooltip>
            <TooltipTrigger asChild>
              <div>
                {orderBy === 'newest' ? (
                  <ArrowDown10
                    className={cn('h-3.5 w-3.5 cursor-pointer', {})}
                    onClick={() => {
                      setOrderBy('oldest');
                    }}
                  />
                ) : (
                  <ArrowDown01
                    className={cn('h-3.5 w-3.5 cursor-pointer', {})}
                    onClick={() => {
                      setOrderBy('newest');
                    }}
                  />
                )}
              </div>
            </TooltipTrigger>
            <TooltipContent>
              {orderBy === 'newest'
                ? 'Newest activity first'
                : 'Oldest activity first'}
            </TooltipContent>
          </Tooltip>
          <div className="flex flex-row gap-1 items-center">
            <Button
              variant={'ghost'}
              className="h-fit p-2"
              onClick={() => {
                toast({
                  title: 'Feature not implemented yet',
                  description:
                    "Slack us for the 'unsubscribe from deal notifications' feature",
                });
              }}
            >
              <div className="text-xs  text-gray-500 text-nowrap">
                Unsubscribe
              </div>
            </Button>

            <CircleUser
              className={cn('h-3.5 w-3.5 cursor-pointer text-gray-500', {})}
            />
          </div>
        </div>
      </div>

      <div className="pb-16">
        <ActivityFeed deal={deal} orderBy={orderBy} />
      </div>
    </div>
  );
});
